import React from "react";

export const Spinner = () => (
    <div className="fa-3x d-flex justify-content-center">
        <i className="fas fa-spinner fa-pulse" />
    </div>
);
